/**
 * Shared date and formatting utilities.
 */

/** Format a number as dollars with commas (e.g., 1234 → "1,234") */
export function fmtDollars(n: number): string {
  return Math.round(n).toLocaleString('en-US');
}

export function getTripDays(startDate: string, endDate: string): string[] {
  if (!startDate || !endDate) return [];
  const days: string[] = [];
  const current = new Date(startDate + 'T00:00:00');
  const end = new Date(endDate + 'T00:00:00');
  while (current <= end) {
    days.push(current.toISOString().split('T')[0]);
    current.setDate(current.getDate() + 1);
  }
  return days;
}

export function formatDayHeader(dateStr: string): { dayName: string; dateLabel: string } {
  const d = new Date(dateStr + 'T00:00:00');
  return {
    dayName: d.toLocaleDateString('en-US', { weekday: 'long' }).toUpperCase(),
    dateLabel: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
  };
}

export function formatDayTab(dateStr: string): string {
  return new Date(dateStr + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase();
}

export function formatDayOption(dateStr: string): string {
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
}
